import React, { useEffect, useState } from 'react';
import { MaskedInput, Typography } from 'fronton-react';
import {
  VerifyCodeWrapper,
  VerifyCodeContainer,
  VerifyCodeLabel,
  rowMargin,
  inputErrorMargin,
} from './styles';
import { getNumbersFromString } from 'utils/get-numbers-from-string';
import { formatPhone } from 'utils/format-phone';
import { useTranslation } from 'react-i18next';
import { ResendButton } from './resend-button';

interface IVerifyCode {
  verifyCode: (phoneNumber: string, code: string) => void;
  loading: boolean;
  error: string | null;
  phoneNumber: string | null;
  sendCode: (phoneNumber: string) => void;
}

export const QA_VERIFY_CODE_INPUT = 'masked-phone-input';

export const VerifyCode: React.FC<IVerifyCode> = ({
  verifyCode,
  loading,
  error,
  phoneNumber = '',
  sendCode,
}) => {
  const { t } = useTranslation();
  const [code, setCode] = useState<string>('');

  useEffect(() => {
    if (code?.length === 4 && phoneNumber) {
      verifyCode(phoneNumber, code);
    }
  }, [code, phoneNumber, verifyCode]);

  const handleResend = () => {
    if (phoneNumber) {
      sendCode(phoneNumber);
    }
  };

  return (
    <VerifyCodeContainer>
      <VerifyCodeWrapper>
        <VerifyCodeLabel>
          <Typography variant="s" size="body_long" color="text-primary">
            {t('loyalty-registration-modal.verify-code-step.send-code')}
          </Typography>
          {phoneNumber && (
            <Typography variant="s" size="body_long" color="text-primary">
              {t('loyalty-registration-modal.verify-code-step.to-phone-number', {
                phoneNumber: formatPhone(phoneNumber),
              })}
            </Typography>
          )}
        </VerifyCodeLabel>
        <MaskedInput
          className={rowMargin}
          data-qa={QA_VERIFY_CODE_INPUT}
          alwaysShowMask
          mask="9  9  9  9"
          onChange={(_, value) => setCode(getNumbersFromString(value))}
          value={code}
          disabled={loading}
          error={!!error}
          size={8}
          center
        />
        {error && (
          <Typography className={inputErrorMargin} variant="caption" color="attention-primary">
            {error}
          </Typography>
        )}
        <ResendButton resend={handleResend} loading={loading} />
      </VerifyCodeWrapper>
    </VerifyCodeContainer>
  );
};
